<!-- 设备管理 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备名称')">
              <a-input :placeholder="$t('请输入设备名称')" v-model="queryParam.deviceName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备类型')">
              <j-dict-select-tag
                v-model="queryParam.deviceType"
                :dictCode="'deviceType'"
                :showSearch="true"
                option-filter-prop="children"
                :placeholder="$t('请选择设备类型')"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备状态')">
              <a-select v-model="queryParam.isOk" :placeholder="$t('请选择设备状态')" allowClear>
                <a-select-option :value="0">{{ $t('正常') }}</a-select-option>
                <a-select-option :value="1">{{ $t('异常') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('执行人员类型')">
                <a-select show-s :placeholder="$t('请选择执行人员类型')" v-model="queryParam.taskImplementType" @change="delete queryParam.taskImplementName" allowClear>
                  <a-select-option :value="0">{{ $t('班组') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('成员') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="queryParam.taskImplementType == 0||queryParam.taskImplementType == 1">
              <a-form-item :label="$t('执行人员')">
                <a-select :showSearch="true" option-filter-prop="children" :placeholder="$t('请选择执行人员(班组)')" v-model="queryParam.taskImplementName" allowClear v-if="queryParam.taskImplementType == 0">
                  <a-select-option :value="item.name" v-for="item in groupList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
                <a-select :showSearch="true" option-filter-prop="children" :placeholder="$t('请选择执行人员(成员)')" v-model="queryParam.taskImplementName" allowClear v-if="queryParam.taskImplementType == 1">
                  <a-select-option :value="item.name" v-for="item in personnelList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('巡检任务')">
                <a-select :showSearch="true" option-filter-prop="children" :placeholder="$t('请选择巡检任务')" v-model="queryParam.id" allowClear>
                  <a-select-option :value="item.id" v-for="item in taskList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <baidu-map
      :center="center"
      :zoom="zoom"
      :style="{ height: '65vh' }"
      :scroll-wheel-zoom="scrollZoom"
      NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE"
      @ready="mapReady"
    >
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
      <!-- 信息窗体 -->
      <bm-info-window :position="position" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
        <div style="width: 100%; display: flex; justify-content: space-between; font-weight: bold">
          <div style="flex: 1;">
            <div>{{ $t('设备编号') }}：{{ mapInfo.deviceNum }}</div>
            <div>{{ $t('设备名称') }}：{{ mapInfo.deviceName }}</div>
            <div>
              {{ $t('设备类型') }}：{{
                deviceTypeList.find((d) => d.value == mapInfo.deviceType) &&
                deviceTypeList.find((d) => d.value == mapInfo.deviceType).text
              }}
            </div>
            <div>{{ $t('设备经度') }}：{{ mapInfo.detectLongitude }}</div>
            <div>{{ $t('设备纬度') }}：{{ mapInfo.detectLatitude }}</div>
            <div>
              <a-button type="primary" size="small" @click="handleHistory(mapInfo)">{{ $t('巡检历史记录') }}</a-button>
            </div>
          </div>
        </div>
      </bm-info-window>
      <!-- 信息窗体-相同经纬度有多个设备 -->
      <!-- <bm-info-window :position="position" :show="dbShow" @close="infoWindowClosedb">
        <div style="width: 100%; display: flex; justify-content: space-between; font-weight: bold;padding-top: 20px;">
          <a-table 
          size="small"
          :columns="columns1"
          :dataSource="dataSource1"
          :pagination="false"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="handleHistory(record)">历史记录</a>
            </span>
          </a-table>
        </div>
      </bm-info-window> -->
    </baidu-map>
    <historyModal ref="historyForm" />
  </div>
</template>
  
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import { getDictItemsFromCache } from '@/api/api.js'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import historyModal from '../deviceManagement/modules/historyModal'

export default {
  name: 'mapList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    historyModal
  },
  data() {
    return {
      description: this.$t('地图展示'),
      url: {
        list: "/jeecg-engineering/inspection/inspectionTask/deviceList",
        queryByDevice: "/jeecg-engineering/inspection/inspectionDevice/queryByDevice",
        inspectionTeam: "/jeecg-engineering/engineering/inspectionTeam/list",
        inspectionUser: "/jeecg-engineering/inspection/inspectionUser/list",
        inspectionTask: "/jeecg-engineering/inspection/inspectionTask/list"
      },
      BMap: '',
      map: '',
      center: { lng: 118.904, lat: 31.915 }, //中心坐标
      centerPoint: { lng: 118.904, lat: 31.915 },
      zoom: 5, //初始缩放比
      scrollZoom: true, //允许鼠标滚轮缩放
      mapInfo: {},
      position: {},
      show: false,
      deviceTypeList: [],
      iconList: {
        1: require("@/assets/inspectionImage/shuiyuan.png"),
        2: require("@/assets/inspectionImage/shuichang.png"),
        3: require("@/assets/inspectionImage/paishui.png"),
        6: require("@/assets/inspectionImage/beiyongshuiyuan.png"),
        7: require("@/assets/inspectionImage/shuibeng.png"),
        8: require("@/assets/inspectionImage/yuanlinlvhua.png"),
        9: require("@/assets/inspectionImage/jinggai.png"),
        12: require("@/assets/inspectionImage/shuibiao.png"),
        13: require("@/assets/inspectionImage/jiayabeng.png"),
        11: require("@/assets/inspectionImage/qibiao.png"),
        14: require("@/assets/inspectionImage/songfeng.png"),
        15: require("@/assets/inspectionImage/dian.png"),
        16: require("@/assets/inspectionImage/deng.png"),
        17: require("@/assets/inspectionImage/qiangji.png"),
        18: require("@/assets/inspectionImage/bianyazhan.png"),
      },
      groupList: [],
      personnelList: [],
      taskList: [],
      dataSource1: [],
    }
  },
  created() {
    this.deviceTypeList = getDictItemsFromCache('deviceType')
    this.getPersonnelList();
    this.getDeptList();
    this.gettaskList();
  },
  computed: {
    columns1() {
      return [
        {
          title: this.$t('设备编号'),
          align:"center",
          dataIndex: 'deviceNum',
          width: 140,
          ellipsis: true,
        },
        {
          title: this.$t('设备名称'),
          align:"center",
          dataIndex: 'deviceName',
          width: 140,
          ellipsis: true,
        },
        {
          title: this.$t('设备类型'),
          align:"center",
          dataIndex: 'deviceType',
          customRender: (text) => {
            return filterDictTextByCache('deviceType', text)
          },
          width: 140,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:120,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  methods: {
    gettaskList() {
        this.taskList = [];
        getAction(this.url.inspectionTask,{pageSize:999,order: 'desc',column: 'createTime'}).then(res => {
          if (res.success) {
            res.result.records.forEach(item => {
              this.taskList.push({
                name:item.taskName,
                id:item.id
              });
            });
          }
        });
      },
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.inspectionUser,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                id: item.userId,
                name: item.userName
              });
            });
          }
        });
      },
      getDeptList(){
        this.groupList = [];
        getAction(this.url.inspectionTeam,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.groupList.push({
                id: item.id,
                name: item.teamName
              });
            });
          }
        })
      },
    searchQuery(){
      this.mapReady({BMap:this.BMap,map:this.map});
    },
    searchReset(){
      this.queryParam = {};
      this.mapReady({BMap:this.BMap,map:this.map});
    },
    //地图默认方法
    mapReady({ BMap, map }) {
        let that = this;
        this.BMap = BMap
        this.map = map
      map.enableDragging()
      map.enableScrollWheelZoom()
      map.enableDoubleClickZoom()
      map.enablePinchToZoom()
      map.enableKeyboard()
      map.clearOverlays()
      let params = {
        deviceName: this.queryParam.deviceName,
        deviceType: this.queryParam.deviceType,
        isOk: this.queryParam.isOk,
        taskImplementName: this.queryParam.taskImplementName,
        taskImplementType: this.queryParam.taskImplementType,
        id: this.queryParam.id,
        source: 2,
      }
      params.pageSize = 1000;
      postAction(this.url.list, params).then((res) => {
        if (res.success) {
          that.dataSource = res.result;
          that.dataSource.forEach((item) => {
            var point = {
              lng: item.detectLongitude,
              lat: item.detectLatitude,
            }
            let myIcon = new BMap.Icon(
                //也可以设置不同坐标点上的icon，需要自己定义
                that.iconList[item.deviceType]||require("@/assets/inspectionImage/shuiyuan.png"),
                new BMap.Size(40, 40), //图标可视区域大小
                { anchor: new BMap.Size(18, 18) } //图标定位点相对于图标左上角的偏移量
            );
            myIcon.setImageSize(new BMap.Size(40, 40)); // 设置icon大小
            var marker = new BMap.Marker(point,{icon: myIcon}) // 创建标注
            map.addOverlay(marker) // 将标注添加到地图中
            //icon标识内容位置
            let label = new BMap.Label(item.deviceId, { offset: new BMap.Size(3, 0) })
            // 文本标识样式
            label.setStyle({
              // fontWeight: 600,
              fontSize: '14px',
              color: 'black',
              backgroundColor: '#fff',
              border: '1px solid #000',
              display: 'none',
            })
            marker.setLabel(label) // 为icon添加文本标识
          })
        }
      })
      this.map.addEventListener('click', (e) => {
        that.mapInfo = that.dataSource.find((al) => al.deviceId == e.cb.Bc.textContent)
        that.position = {
          lng: that.mapInfo && that.mapInfo.detectLongitude,
          lat: that.mapInfo && that.mapInfo.detectLatitude,
        }
        that.show = true
        // getAction(this.url.list,{pageSize:999,detectLongitude:that.position.lng,detectLatitude:that.position.lat}).then(val=>{
        //   if(val.success){
        //     if(val.result.records.length>1){
        //       that.dbShow = true;
        //       that.show = false;
        //       that.dataSource1 = val.result.records;
        //     }else{
        //       that.show = true
        //       that.dbShow = false;
        //     }
        //   }
        // })
      })
    },
    // 关闭窗体
    infoWindowClose() {
      this.show = false
    },
    infoWindowClosedb() {
      this.dbShow = false
    },
    // 打开窗体
    infoWindowOpen() {
      this.show = true
    },
    handleHistory(row){
      this.$nextTick(()=>{
        this.$refs.historyForm.init({...row,isMap:true,id:row.deviceId});
      })
    }
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>